import styled from 'styled-components'

const TwoColumnContainer = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  column-gap: 20px;
  min-height: 0;
`

export default TwoColumnContainer
